import { render } from "./HandleRecords.vue?vue&type=template&id=1343968e&ts=true"
import script from "./HandleRecords.vue?vue&type=script&lang=tsx"
export * from "./HandleRecords.vue?vue&type=script&lang=tsx"

import "./HandleRecords.vue?vue&type=style&index=0&id=1343968e&lang=scss&scope=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__